export function Spinner() {
  return (
    <div className="flex justify-center items-center p-12">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rhs-maroon"></div>
    </div>
  )
}
